import React from 'react';
import cn from 'classnames';

import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';

import CN from './AlertPanel.module.scss';

const AlertPanel = ({ tag, children, variant, position, size, variantInvert }) => {
  const { isDarkMode } = useTheme();
  return (
    <div
      data-bem="AlertPanel"
      data-tag={fromAnyToTrimmed(tag)}
      className={cn({
        [CN.component]: true,
        [CN[`${variant}Variant`]]: variant,
        [CN[`${position}Position`]]: position,
        [CN[`${size}Size`]]: size,
        [CN.variantInvert]: variantInvert,
        [CN.dark]: isDarkMode,
      })}
    >
      {children}
    </div>
  );
};

export default AlertPanel;
